import React, { useEffect, createContext, Context } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Expression, FilterState } from '../types';
import { SelectDisabled, SelectFilter } from '../selectors';
import { getFilter } from '../utils';
import FilterExpression from './FilterExpression';
import { setQuery } from '../../actions';


const Container = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
}));

export type FilterScope = {
    disabled: boolean
}

export const FilterContext: Context<FilterScope | undefined> = createContext<FilterScope | undefined>(undefined);

const FilterContainer: React.FC<{
    hidden: boolean
}> = ({
    hidden
}) => {
        const dispatch = useDispatch();
        const expression: Expression = useSelector(SelectFilter);
        const disabled: boolean = useSelector(SelectDisabled);

        useEffect(() => {
            dispatch(setQuery(getFilter(expression)));
        }, [expression]);

        const filterScope: FilterScope = {
            disabled
        }

        return expression ? <FilterContext.Provider value={filterScope}>
            <Box>
                <Container>
                    <FilterExpression expression={expression} path={[]} hidden={hidden}/>
                </Container>
            </Box>
        </FilterContext.Provider> : null;
    }

export default FilterContainer;
